module.exports = __webpack_public_path__ + "static/media/Account-sample.03179a2b.png";